export const reportHeadingList = '/configuration/report-heading/detail'
// Fair Evaluation Setup Api
export const fairEvaluationListApi = 'configuration/fair-evaluation-setup/list'
export const fairEvaluationStoreApi = 'configuration/fair-evaluation-setup/store'
export const awarenessInfoStoreApi = 'managementInformationSystem/awareness-info/store'
export const awarenessInfoListApi = 'managementInformationSystem/awareness-info/list'
export const awarenessInfoUpdateApi = 'managementInformationSystem/awareness-info/update'
export const fairEvaluationToggleStatusApi = 'configuration/fair-evaluation-setup/toggle-status'
export const fairEvaluationShowApi = 'configuration/fair-evaluation-setup/show'
export const disabilityTypeListNewApi = 'configuration/disability-type/listnew'
// Patient Api
export const patientBaseUrlApi = 'ims/patients/'
export const patientApplicationListApi = patientBaseUrlApi + 'list'
export const patientApplicationReportListApi = patientBaseUrlApi + 'listreport'
export const patientRecommendedListApi = patientBaseUrlApi + 'forwarded-list'
export const patientApprovedListApi = patientBaseUrlApi + 'approved-list'
export const patientStore = patientBaseUrlApi + 'store'
export const patientUpdate = patientBaseUrlApi + 'update'
// export const centerChangeRequestListApi = patientBaseUrlApi + 'center-change-request-list'
// export const centerChangeRequestApproveApi = patientBaseUrlApi + 'approve-center-change-request'
// export const centerChangeRequestRejectApi = patientBaseUrlApi + 'reject-center-change-request'
export const patientForwardApi = patientBaseUrlApi + 'forward'
export const patientApproveApi = patientBaseUrlApi + 'approve'
export const patientRejectApi = patientBaseUrlApi + 'reject'
// patient Report Api
export const patientReportApi = 'ims/reports/patient-report'
// chenter change request
const request = 'ims/center-change-request/'
export const centerChangeRequestListApi = request + 'list'
export const submitCenterChangeRequest = request + 'store'
export const centerChangeRequestApproveApi = request + 'approve'
export const centerChangeRequestRejectApi = request + 'reject'
